import { render, staticRenderFns } from "./CustomerUploader.vue?vue&type=template&id=4bf64fb5&scoped=true"
import script from "./CustomerUploader.vue?vue&type=script&lang=js"
export * from "./CustomerUploader.vue?vue&type=script&lang=js"
import style0 from "./CustomerUploader.vue?vue&type=style&index=0&id=4bf64fb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf64fb5",
  null
  
)

export default component.exports